import React, {useContext} from "react";
import NotificationContext from "./NotificationContext";
import './NotificationBar.css';
import STC from "../STCFactory/STCFactory";

const NotificationBar = () => {
    const notificationCtx = useContext(NotificationContext);
    return (
        notificationCtx.notification !== null && (
            <div className='notification-system-container'>
            <div className={'notification-bar-container'}>
                <STC.Alert variant={notificationCtx.notification} className={notificationCtx.notification}>{notificationCtx.notificationText}</STC.Alert>
            </div>
            </div>
        )
    );
};
export default NotificationBar;